export const LOADING_SUCCESS = "[URL_FILTERS] LOADING_SUCCESS";
export const LOADING_FAILURE = "[URL_FILTERS] LOADING_FAILURE";
export const REMOVE_ITEMS_SUCCESS = "[URL_FILTERS] REMOVE_ITEMS_SUCCESS";
export const REMOVE_ITEMS_FAILURE = "[URL_FILTERS] REMOVE_ITEMS_FAILURE";
export const CHECK_URL_CHANGE = "[URL_FILTERS] CHECK_URL_CHANGE";
export const CHECK_URL_SUCCESS = "[URL_FILTERS] CHECK_URL_SUCCESS";
export const CHECK_URL_FAILURE = "[URL_FILTERS] CHECK_URL_FAILURE";
export const CLEAR_CHECK_URL = "[URL_FILTERS] CLEAR_CHECK_URL";
export const CANCEL_CHECK_URL = "[URL_FILTERS] CANCEL_CHECK_URL";
export const ADD_URL_TO_LIST_SUCCESS = "[URL_FILTERS] ADD_URL_TO_LIST_SUCCESS";
export const PARSE_CSV_FILE = "[URL_FILTERS] PARSE_CSV_FILE";
export const PARSE_CSV_FILE_SUCCESS = "[URL_FILTERS] PARSE_CSV_FILE_SUCCESS";
export const PARSE_CSV_FILE_FAILURE = "[URL_FILTERS] PARSE_CSV_FILE_FAILURE";
export const CHECK_CSV_FILE_SUCCESS = "[URL_FILTERS] CHECK_CSV_FILE_SUCCESS";
export const CHECK_CSV_FILE_FAILURE = "[URL_FILTERS] CHECK_CSV_FILE_FAILURE";
export const UPLOAD_CSV_FILE_FAILURE = "[URL_FILTERS] UPLOAD_CSV_FILE_FAILURE";
export const UPLOAD_CSV_FILE_PARTIAL_SUCCESS =
  "[URL_FILTERS] UPLOAD_CSV_FILE_PARTIAL_SUCCESS";
export const CLEAR_CSV_FILE = "[URL_FILTERS] CLEAR_CSV_FILE";
